import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { ArrowUpRight, Clock, Loader2 } from "lucide-react";
import { PageHero, Reveal } from "../components/Reveal";
import { CTABanner } from "../components/CTABanner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Blog() {
  const [posts, setPosts] = useState(null);

  useEffect(() => {
    document.title = "Insights & Blog — DG Hubs | Digital Marketing Agency Delhi NCR";
    axios.get(`${API}/blog`).then((r) => setPosts(r.data)).catch(() => setPosts([]));
    return () => { document.title = "DG Hubs — Digital Marketing Agency in Delhi NCR"; };
  }, []);

  return (
    <main data-testid="blog-page">
      <PageHero
        eyebrow="Insights & Ideas"
        title="NOTES FROM THE DIGITAL FRONTLINE."
        sub="Practical guides on digital marketing, SEO, ads, websites and business automation — written for growing businesses, not marketers."
      />

      <section className="bg-dg-navy pb-24 sm:pb-32">
        <div className="mx-auto max-w-7xl px-5 sm:px-8">
          {posts === null ? (
            <div className="flex justify-center py-20"><Loader2 size={28} className="animate-spin text-dg-cyan" /></div>
          ) : posts.length === 0 ? (
            <p className="py-20 text-center text-slate-400">Articles coming soon.</p>
          ) : (
            <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
              {posts.map((p, i) => (
                <Reveal key={p.id} delay={(i % 3) * 0.08}>
                  <Link
                    to={`/blog/${p.slug}`}
                    data-testid={`blog-card-${p.slug}`}
                    className="group flex h-full flex-col rounded-3xl border border-white/8 bg-white/[0.03] p-8 transition-all duration-500 hover:-translate-y-2 hover:border-dg-cyan/40 hover:shadow-[0_0_35px_rgba(0,184,212,0.12)]"
                  >
                    <div className="flex flex-wrap gap-2">
                      {p.tags.map((t) => (
                        <span key={t} className="rounded-full border border-dg-cyan/25 bg-dg-cyan/5 px-3 py-1 font-mono text-[10px] uppercase tracking-[0.15em] text-dg-cyan">{t}</span>
                      ))}
                    </div>
                    <h2 className="font-display mt-5 text-xl font-bold leading-snug text-white transition-colors group-hover:text-dg-cyan">{p.title}</h2>
                    <p className="mt-3 flex-1 text-sm leading-relaxed text-slate-400">{p.excerpt}</p>
                    <div className="mt-6 flex items-center justify-between border-t border-white/8 pt-5">
                      <span className="flex items-center gap-1.5 text-xs text-slate-500">
                        <Clock size={13} /> {p.read_time} min read · {new Date(p.created_at).toLocaleDateString("en-IN", { dateStyle: "medium" })}
                      </span>
                      <ArrowUpRight size={16} className="text-dg-cyan transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                    </div>
                  </Link>
                </Reveal>
              ))}
            </div>
          )}
        </div>
      </section>

      <CTABanner title="READ ENOUGH. LET'S BUILD." sub="Insights are free — execution is where growth happens. Let's talk about your business." />
    </main>
  );
}
